import { useContext } from 'react';
import { AnalyticsContext } from '../AnalyticsContext/AnalyticsContext';
import { TrackingEvent } from '../AnalyticsContext/TrackingEvent';
import { logRejectionsToSentry } from '../Sentry';
import { useServices } from '../services/Services';
import { useEventBus } from '../util/EventBus';

const REPORT_METRIC_ENDPOINT = `/api/unicron/public/report-metric`;

export const PerformanceAnalyticsDispatcher = () => {
  const { bus } = useContext(AnalyticsContext);
  const sendBeacon = useServices().network.sendBeacon;

  useEventBus(bus, ({ name, data }) => {
    const webVitals = data.eventData?.webVitals;

    if (name === TrackingEvent.PERFORMANCE_REPORTED && webVitals) {
      webVitals.forEach(item => {
        logRejectionsToSentry('Reporting web vitals', () =>
          sendBeacon(REPORT_METRIC_ENDPOINT, JSON.stringify(item)),
        );
      });
    }
  });

  return null;
};
